import { NgClass } from "@angular/common";
import { Component, input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "claas-app-section-header",
  templateUrl: "./app-section-header.html",
  styleUrl: "./app-section-header.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class AppSectionHeader {
  isMultiline = input(false);

  isModalHead = input(false);
}
